<template>
  <div class="mb-3">
    <div class="d-flex justify-content-between">
      <div class="w-100">
        <b-input-group>
          <b-input-group-prepend is-text>
            <b-icon icon="calendar-event" />
          </b-input-group-prepend>
          <b-input
            :value="value.dateString"
            type="date"
            @change="updateFilter('dateString', $event)"
          />
        </b-input-group>
      </div>
      <div class="ml-2">
        <b-button variant="primary" size="sm" @click="$emit('clear')">
          <b-icon icon="x" />
        </b-button>
      </div>
    </div>
    <b-input-group class="mt-2">
      <b-input-group-prepend is-text>
        <b-icon icon="scissors" />
      </b-input-group-prepend>
      <b-form-select
        :value="value.barberIds"
        :options="barberOptions"
        multiple
        :select-size="4"
        @change="updateFilter('barberIds', $event)"
      />
    </b-input-group>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      required: true,
    },
    barbers: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    barberOptions() {
      return this.barbers.map(b => ({ value: b.id, text: b.name }))
    },
  },
  methods: {
    updateFilter(key, val) {
      this.$emit('filter-change', { ...this.value, [key]: val })
    },
  },
}
</script>
